module.exports = __webpack_public_path__ + "static/media/teampic1.438fd213.png";